<template>
  <b-container>
    <p>{{ message }}</p>
    <b-button
      @click="$router.push({path: '/'})">
      Back to main page
    </b-button>
  </b-container>
</template>

<script>
export default {
  name: "ErrorNotification",
  data() {
    return {
      message: ''
    }
  },
  created() {
    this.message = this.$route.params.message
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ErrorNotificationPage.vue